import React from 'react';

import { Col, Card, Typography, Divider } from 'antd';

import { Highlight as HighlightType } from '../../../types.generated';
import { formatNumber } from '../../shared/formatNumber';

type Props = {
    highlight: HighlightType;
    shortenValue?: boolean;
};

export const Highlight = ({ highlight, shortenValue }: Props) => {
    return (
        <Col sm={24} md={12} lg={12}>
            <Card className="mb-2">
                <div className="pa-2">
                    <div className="f-left-border-highlight f-color-base-purple darker-border py-0">
                        <Typography.Title className="f-text-big-title mb-0" level={1}>
                            {(shortenValue && formatNumber(highlight.value)) || highlight.value}
                        </Typography.Title>
                        <Typography.Text className="f-text-medium-content f-color-dark-black-s70">
                            {highlight.title}
                        </Typography.Text>
                    </div>
                </div>
                <Divider className="ma-0" />
                <div className="pa-2">
                    <Typography.Text className="f-text-content f-color-dark-black-s70">
                        {highlight.body || '-'}
                    </Typography.Text>
                </div>
            </Card>
        </Col>
    );
};
